import type { ICarePlan } from "@domain/CarePlan";
import { ConditionType, type IConditionDto, ConditionBase, ConditionState, type IConditionLabelOptions, type IVehicle, ConfigurationType } from "..";
import { WorkOrderType } from "@domain/CarePlan/WorkOrders/WorkOrderType";

export class BrakesCondition extends ConditionBase
{

    constructor( vehicle: IVehicle, model: IConditionDto )
    {
        super( vehicle, model, ConditionType.Brakes, ConfigurationType.Monthly, false );
        this.icon = 'help-me:brakes';
        this.ordinal = 4;
        this.initialise();
    }

    /**
     * Applies the care plan state to the condition
     * @param carePlan 
     */
    applyCarePlan( carePlan: ICarePlan )
    {
        this.workOrderConfiguration = carePlan.getItem( WorkOrderType.BrakeService );
    }

    /**
     * Gets the labels for the condition.  The labels are used to provide meaningful
     * user interface statements/prompts that are specific to the condition
     */
    override getLabels(): IConditionLabelOptions 
    {
        return {
            name: "Brakes",
            shortName: 'Brakes',
            longName: "Brakes",
            intervalJustCompletedMessage: "Brakes repair was just completed",
            cta: "Book a service/fix",
            description: 'Manage your Brakes condition',
            maintenanceVerb: 'Brakes',
            protectedByLabel: 'Your car is protected by'
        };
    }

    /**
     * Gets the description for the interval update for this condition
     * @returns 
     */
    protected override getIntervalDescription()
    {
        return 'Check your Brake Pads, Discs and Rotors and replace if necessary';
    }

    /**
     * Gets the action message for the service note
     */
    override getActionMessage() 
    {
        const message = 'Check your Brake Pads, Discs and Rotors and replace if necessary';
        switch( this.state )
        {
            case ConditionState.Due: return message;
            case ConditionState.Overdue: return message;
            case ConditionState.Critical: return message;
            default: return '';
        }
    }
    
}
